import { options, title } from 'Containers/steps/Consts'
import { t } from 'i18next'
import { ManageSubscriptionStep, ManageSubscriptionStepId } from 'types/manageSubscriptionTypes'

export enum CancellationReasonGoalAchievedOption {
  LearnMore = 'learnMore',
  CancelAnyway = 'cancelAnyway'
}

export function getCancellationReasonGoalAchievedStep(): ManageSubscriptionStep {
  return {
    id: ManageSubscriptionStepId.CancellationReasonGoalAchieved,
    type: 'single-select',
    wordings: {
      title: t(`${ManageSubscriptionStepId.CancellationReasonGoalAchieved}.${title}`)
    },
    options: [
      {
        id: CancellationReasonGoalAchievedOption.LearnMore,
        label: t(`${ManageSubscriptionStepId.CancellationReasonGoalAchieved}.${options}.${CancellationReasonGoalAchievedOption.LearnMore}`)
      },
      {
        id: CancellationReasonGoalAchievedOption.CancelAnyway,
        label: t(`${ManageSubscriptionStepId.CancellationReasonGoalAchieved}.${options}.${CancellationReasonGoalAchievedOption.CancelAnyway}`)
      }
    ]
  }
}
